import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import EcoleDetail from './ecole-detail';
import Ecole from './ecole';
import EcoleUpdate from './ecole-update';
import EcoleDeleteModal from './ecole-delete-modal';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={EcoleUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={EcoleUpdate} />
      <ErrorBoundaryRoute path={`${match.url}/:id`} component={EcoleDetail} />
      <ErrorBoundaryRoute path={match.url} component={Ecole} />
    </Switch>
    <ErrorBoundaryRoute path={`${match.url}/:id/delete`} component={EcoleDeleteModal} />
  </>
);

export default Routes;
